import React, { Fragment, useState } from "react"
import { Dialog, Transition } from "@headlessui/react"
import CloseIcon from "../icons/close"
import ChevronIcon from "../icons/chevron"

function WpGallery({ children, ...rest }): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)
  const [slide, setSlide] = useState(0)

  function closeModal(): void {
    setIsOpen(false)
  }

  function openModal(): void {
    setIsOpen(true)
  }

  const figures =
    children && children.length > 0
      ? children.filter(c => c.type === `figure`)
      : [children]
  const slideProps = figures[slide]?.props?.children?.props
  // console.log({ figures, rest, slideProps })
  return (
    <figure className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {figures.map((figure, index) => (
        <button
          key={index}
          type="button"
          onClick={(): void => {
            setSlide(index)
            openModal()
          }}
        >
          {figure}
        </button>
      ))}

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[99999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-90" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full main-container transform overflow-hidden  p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex relative">
                    <button
                      className="rotate-180 absolute h-full left-4 opacity-50 hover:opacity-100"
                      type="button"
                      onClick={(): void => setSlide(slide - 1)}
                    >
                      <ChevronIcon className="w-8 h-8 text-lightgray" />
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center bg-white w-full  border-8 border-white text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                      onClick={(): void => setSlide(slide + 1)}
                    >
                      <img
                        className="w-full"
                        loading="lazy"
                        src={
                          slideProps?.src ??
                          `https://georgiancollege.ca/i/logos/colour/accelerator-icon.png`
                        }
                        alt={slideProps?.alt ?? `Georgian Accelerator`}
                        srcSet={slideProps?.srcSet}
                      />
                    </button>
                    <button
                      className="absolute h-full right-4 opacity-50 hover:opacity-100"
                      type="button"
                      onClick={(): void => setSlide(slide + 1)}
                    >
                      <ChevronIcon className="w-8 h-8 text-lightgray" />
                    </button>
                  </div>
                  <Dialog.Title
                    as="h3"
                    className="text-sm lg:text-xl flex font-medium mt-4 leading-6 text-lightgray"
                  >
                    <span className="mr-auto">
                      {slideProps?.alt ?? `Georgian Accelerator`}
                    </span>
                    <button type="button" onClick={closeModal}>
                      <CloseIcon className="w-6 h-6 text-lightgray" />
                    </button>
                  </Dialog.Title>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </figure>
  )
}

export default WpGallery
